import ExperienceTab from "../hero/experience-tab";
import { Footer } from "../hero/footer";
import Intro from "../hero/intro";
import RecommendationHero from "../hero/recommendations";
import AboutMeSection from "../section/aboutme";
import Projects from "../section/projects";
import AboutMe from "../ui/aboutme";
import ProjectsList from "../ui/projectlist";

export default function Home() {
  interface Testimonial {
    quote: string[]; // Changed to an array of strings for multiple paragraphs
    recommender: string;
  }
  const myTestimonials: Testimonial[] = [
    {
      quote: [
        "Izzat is an diligent student who has shown a remarkable aptitude for Linux. He has demonstrated a deep understanding of the course material where he applied his knowledge to practical exercises of managing local users and groups, monitoring and managing Linux processes, controlling access to files with file system permissions, analyzing and storing log files, managing logical volumes, scheduling future tasks, tuning system performance, developing, managing, and running containers.",
        "I highly recommend Izzat for future education pursuing university. His hard work and dedication to learning make him an excellent candidate for any higher tertiary program he wishes to pursue. I am confident that he will continue to excel in his academic pursuits and bring credit to any employer he joins.",
      ],
      recommender: "Keyon Genesis Kanan, C330 Linux Administration Lecturer",
    },
    {
      quote: [
        "Izzat, displayed a strong fighting spirit by consistently seeking to improve work quality and efficiency, readily assisting others and proactively striving for the betterment with the unit. His keen observational skills and critical thinking enabled him to identify and solve issues effectively.",
        'Notably, as an NSF, he spearheaded the creation of a comprehensive "Mega File" consolidating all Excel sheets for easy information access, significantly reducing administrative burden.',
        "Leveraging his IT background, he independently develop a Telegram Bot with functions for attendance taking, SOFUN conduct overviews.",
      ],
      recommender: "Commanding Officer (MAJ), Singapore Army",
    },
    {
      quote: [
        "Izzat is an exceptionally professional and highly motivated soldier who consistently performs his duties with efficiency and dedication. He often stays late to ensure all tasks are completed to a high standard, demonstrating a strong sense of responsibility.",
        "A skilled Excel user, he has developed complex formulas to streamline training-related tasks, assist the Node Sergeant Major with training plans and fairly track the duty roster.",
        "His excellent time management allows him to complete all his tasks on time and with quality, significantly contributing to the unit's effectiveness.",
        "His exemplary conduct and strong leadership potential make him a truly deserving candidate for the CO coin.",
      ],
      recommender: "Commanding Officer (LTC), Singapore Army",
    },
  ];
  return (
    <>
      <Intro />
      <AboutMeSection />
      <AboutMe />
      <ExperienceTab />
      <Projects />
      <ProjectsList />
      {/* <FunSideBanner
        buttonText={"here"}
        buttonLink={"https://www.google.com"}
      /> */}
      <RecommendationHero testimonials={myTestimonials} />
      <Footer />
    </>
  );
}
